import React, {useEffect, useState} from 'react';
import axios from "axios";
import {API_BASE_URL} from "../config";
import Modal from 'react-modal';
import '../assets/css/Users.css';
import {useNavigate} from "react-router-dom";
import Button from "../components/Elements/Button";
import {generateStrongPassword} from "../utils/passwordUtils";

const DeletedUsersList = () => {
    const [users, setUsers] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => {
        setIsModalOpen(true) ;
    };
    const closeModal = () => setIsModalOpen(false);
    const [user, setUser] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('')
    const [department, setDepartment] = useState('')
    const [registerMessage, setRegisterMessage] = useState('');
    const roles = ['Administrateur', 'Editeur', 'Consultant'];
    const [departments, setDepartments] = useState([]);
    const [password, setPassword] = useState('');
    const [triggerUserRefresh, setTriggerUserRefresh] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_all_departments`, {user, email, password, role})
            .then(response => {
                setDepartments(response.data);
            })
            .catch(error => {
                // Handle network errors
                console.error('Error:', error);
                setRegisterMessage('An error occurred. Please try again later.');
            });

        axios.post(`${API_BASE_URL}/get_deleted_users`)
            .then(res => {
                const {data} = res;
                if (Array.isArray(data) && data.length > 0) {
                    const usersArray = data.map(user => ({
                        ...user,
                        departmentNames: user.department_names ? user.department_names.split(',') : [], // Convert to array
                        departmentIds: user.department_id ? user.department_id.split(',').map(id => id.trim()) : [] // Convert to array and trim spaces
                    }));

                    console.log(usersArray);
                    setUsers(usersArray);
                } else {
                    console.warn('No users found or invalid response structure');
                }
            })
            .catch(error => {
                console.error('Error fetching user data:', error);
            });

    }, [email, password, role, user, triggerUserRefresh]);


    useEffect(() => {
        document.title = 'Utilisateurs'
    }, []);

    const handleRegister = (e) => {
        e.preventDefault();

        axios.post(`${API_BASE_URL}/register`, {user, email, password, role})
            .then(response => {
                if (response.data.status === 'ok') {
                    // Successful login
                    // Perform actions such as setting user session, redirecting, etc.
                    setRegisterMessage('Utilisateur enregistré avec succès');
                    closeModal();
                    setTriggerUserRefresh((prev) => !prev)

                } else {
                    // Wrong credentials
                    setRegisterMessage('Une erreur est survenue.');
                }
            })
            .catch(error => {
                // Handle network errors
                console.error('Error:', error);
                setRegisterMessage('An error occurred. Please try again later.');
            });

    }

    useEffect(() => {
        console.log('ok')
    }, [user]);

    return (<div>
        <h2>Utilisateurs supprimés</h2>

        <div className={"display-flex gap-10 bg-white p-20 border-radius-10 mb-20"}>
            <i className={"fa-regular fa-info info-bulle"}/>
            <span>Cette liste contient les anciens utilisateurs qui ont été archivés. Ces utilisateurs n'ont plus la possibilité de se connecter, de modifier ou d'avoir d'intéraction avec nos outils.</span>

        </div>
        <table className="ticket-table">
            <thead>
            <tr>
                <th>Utilisateur</th>
                <th>Email</th>
                <th>Rôle</th>
                <th>Département</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {users.map(user => (
                // Cliquer sur un utilisateur renvoie sur sa page pour l'administrer
                <tr key={user.id} className={'tr-user'} onClick={() => navigate('/utilisateur/' + user.id)}>
                    <td>
                        {user.firstname + ' ' + user.lastname}
                    </td>

                    <td>
                        {user.email}
                    </td>

                    <td>
                        {user.role}
                    </td>

                    <td>
                        {
                            // Ajout d'un espace entre les noms des départements pour que ce soit plus joli
                            user.department_names !== null && user.department_names.split(',').join(', ')
                        }
                    </td>
                </tr>))}
            </tbody>
        </table>

        <div className={"h-separator"}/>

        <div className={"display-flex gap-20 mt-20"}>
            <Button iconBackground={'bg-third'} onClick={() => openModal()}
                    icon={'fa-plus'} label={'Ajouter un utilisateur'}
                    textClassNames={'bg-third '}
                    iconClasseNames={'color-white'} disableLink/>

            <Button iconBackground={'bg-orangered'} onClick={() => navigate('/utilisateurs-supprimes')}
                    icon={'fa-trash'} label={'Voir les utilisateurs supprimés'}
                    textClassNames={'bg-orangered '}
                    iconClasseNames={'color-white'} disableLink/>
        </div>


        {/* Modal for Register Component */}
        <Modal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            contentLabel="Ajouter un utilisateur"
            className="modal"
            overlayClassName="overlay"
            shouldCloseOnOverlayClick={true} // This will close the modal when the overlay is clicked
        >
            <div className="register-container">
                <form className="register-form" onSubmit={handleRegister}>
                    <h2 className="title">Création d'un utilisateur</h2>
                    <div className="input-container mb-0">
                        <div className="input-icon">
                            <i className="fas fa-user  color-third"></i>
                        </div>
                        <input className="input" type="text" placeholder="Prénom et nom" required
                               autoFocus={true}
                               value={user} onChange={(e) => setUser(e.target.value)}/>
                    </div>
                    <div className="input-container mb-0">
                        <div className="input-icon">
                            <i className="fas fa-envelope  color-third"></i>
                        </div>
                        <input className="input" type="email" placeholder="Email" required
                               value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </div>
                    <div className="input-container mb-0 ">
                        <div className="input-icon">
                            <i className="fas fa-lock  color-third"></i>
                        </div>
                        <input
                            className="input"
                            type="text"
                            placeholder="Mot de passe"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <span className="btn-generate" onClick={()=> setPassword( generateStrongPassword)}><i
                            className="fa-solid fa-arrows-rotate"></i></span>

                    </div>
                    <div className="input-container custom-select mb-0">
                        <div className="input-icon">
                            <i className="fa-solid fa-industry color-third"></i>
                        </div>
                        {/* Dropdown for roles */}
                        <select
                            className="input"
                            value={department}
                            onChange={(e) => setDepartment(e.target.value)}
                            required
                        >
                            <option value="" disabled hidden>Choisir un département</option>
                            {departments.map((department) => (
                                <option key={department.id} value={department.id}>{department.name}</option>))}
                        </select>
                    </div>
                    <div className="input-container custom-select">
                        <div className="input-icon">
                            <i className="fa-solid fa-user-lock color-third"></i>
                        </div>
                        {/* Dropdown for roles */}
                        <select
                            className="input"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            required
                        >
                            <option value="" disabled hidden>Choisir un rôle</option>
                            {roles.map((roleOption) => (
                                <option key={roleOption} value={roleOption}>{roleOption}</option>))}
                        </select>
                    </div>
                    {/* Display login error message */}
                    {registerMessage && <p className="error-message">{registerMessage}</p>}
                    <div className={"display-flex justify-content-end gap-10 btn-container"}>

                        <button className="btn-submit-account cancel" style={{backgroundColor: "#ce3b2a"}}
                                onClick={closeModal}>Annuler
                        </button>
                        <button className="btn-submit-account" type="submit">Enregistrer un utilisateur</button>


                    </div>
                </form>
            </div>
        </Modal>
    </div>)
}

export default DeletedUsersList;